import axios from "./axios"

/**
 * 地址查詢服務
 * @param {*} k 
 */
const address = k => {
    return axios.get(`/api/v1/cadastre/address?k=${k}`).then(res => res.data)
}

export default {
    address
}